// extracted by mini-css-extract-plugin
export var heroImage = "_bw-1";
export var modal = "_bw-0";